export default __webpack_public_path__ + "static/media/black_knight.49d17a41.png";